import React from "react";
import { motion } from "framer-motion";
import { useLang, pick } from "../context/LanguageContext";
import { t } from "../data/translations";

export const Story = ({ settings }) => {
  const { lang } = useLang();
  const chapters = settings?.story_chapters || [];

  return (
    <section id="story" className="relative bg-brand-surface border-y border-brand-line py-24 sm:py-32 overflow-hidden" data-testid="story-section">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <p className="text-brand-gold uppercase tracking-[0.3em] text-xs mb-4">{pick(settings?.about_title, lang)}</p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-2xl mb-20 text-balance">
          {lang === "es" ? "Hecho con manos, corazón y una pizca de bendición." : "Made with hands, heart & a little blessing."}
        </h2>

        <div className="space-y-16 sm:space-y-24">
          {chapters.map((ch, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className="relative grid grid-cols-1 md:grid-cols-12 gap-6 items-start"
              data-testid={`story-chapter-${i}`}
            >
              <div className="md:col-span-4 relative">
                <span className="font-display font-black text-[9rem] sm:text-[12rem] leading-none text-brand-primary/12 select-none block -mb-8 md:mb-0">
                  {ch.num}
                </span>
              </div>
              <div className="md:col-span-8 md:pt-8">
                <h3 className="font-display text-2xl sm:text-4xl mb-4">{pick(ch.title, lang)}</h3>
                <p className="text-lg text-brand-muted leading-relaxed max-w-2xl">{pick(ch.body, lang)}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
